import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';

import {
    Body1,
    Button,
    Modal,
    Stack,
} from '@myphx-engineering/phx-design-system';

import { getFragment } from '../../../graphql/client/helpers/get-fragment';
import {
    type DigitallyReceivedPrescriberOrderInfoFragment,
    RequestPrescriberOrderModificationDocument,
} from '../../../graphql/generated/graphql';
import { ConditionalComponent } from '../../utility/ConditionalComponent';

export type SwitchOtherOptionsModalProps = {
    isOpen: boolean;
    order: DigitallyReceivedPrescriberOrderInfoFragment;
    toggle: () => void;
};

export const SwitchOtherOptionsModal = ({
    isOpen,
    order,
    toggle,
}: SwitchOtherOptionsModalProps) => {
    const { t } = useTranslation();

    const prescriber = getFragment(order.prescriber);
    const phone = prescriber.phoneNumber ?? null;

    const [RequestPrescriptionModification] = useMutation(
        RequestPrescriberOrderModificationDocument
    );

    const handleCallPrescriber = async () => {
        await RequestPrescriptionModification({
            variables: {
                prescriberOrderId: order.drxId ?? '',
                preventAutoRoute: true,
            },
        });

        if (phone) {
            location.href = `tel:${phone}`;
        }
    };

    return (
        <Modal title={t('otherOptions.title')} opened={isOpen} onClose={toggle}>
            <Stack gap="md">
                <Stack gap="sm">
                    <Body1>{t('otherOptions.body.part1')}</Body1>
                    <Body1>{t('otherOptions.body.part2')}</Body1>
                </Stack>
                <Stack gap="sm">
                    <ConditionalComponent condition={Boolean(phone)}>
                        <Button
                            fullWidth
                            variant="filled"
                            onClick={handleCallPrescriber}
                        >
                            {t('otherOptions.button.callPrescriber')}
                        </Button>
                    </ConditionalComponent>
                    <Button fullWidth variant="outline" onClick={toggle}>
                        {t('otherOptions.button.close')}
                    </Button>
                </Stack>
            </Stack>
        </Modal>
    );
};
